<div class="preloader" [ngClass]="windowLoad ? 'd-none':''">
    <img src="assets/img/logo/polypharm-icon-transparent.png" class="preloader-image" alt="preloader" style="max-width: 200px"/>
</div>
